import { Dialog, DialogContent, DialogActions, DialogTitle, MenuItem, Button, Grid2 } from '@mui/material'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import React, { useState, useEffect } from 'react';
import MyTextInput from '../../../components/inputs/MyTextInput';
import MyPasswordInput from '../../../components/inputs/MyPasswordInput';
import MyAutoComplete from '../../../components/inputs/MyAutoComplete';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';

function CrearEditarUsuarioModal({ open, onClose, refresh, usuario, isEditing }) {

    const [perfiles, setPerfiles] = useState([]);

    const validationSchema = Yup.object({
        nombre: Yup.string().required('El nombre es obligatorio'),
        apellido: Yup.string().required('El apellido es obligatorio'),
        email: Yup.string().email('El email no es válido').required('El email es obligatorio'),
        id_perfil: Yup.number().required('El perfil es obligatorio'),
        estado: Yup.number().required('El estado es obligatorio'),
    });

    const initialValues = {
        nombre: usuario?.nombres || '',
        apellido: usuario?.apellidos || '',
        email: usuario?.email || '',
        password: null,
        id_perfil: usuario?.id_perfil || '',
        estado: usuario?.estado || '',
    };

    const findPerfiles = async () => {
        try {
            const response = await myApi.get('/perfiles/');

            let perfiles = [];
            response.data.data.forEach(perfil => {
                perfiles.push({ value: perfil.id_perfil, label: perfil.nombre_perfil });
            });
            setPerfiles(perfiles);
        } catch (error) {
            console.error('Error fetching profiles:', error);
        }
    };

    useEffect(() => {
        findPerfiles();
    }, [usuario]);

    const handleSubmit = async (values) => {

        const payload = {
            nombre: values.nombre,
            apellido: values.apellido,
            email: values.email,
            password: values.password,
            id_perfil: values.id_perfil,
            estado: values.estado,
        };

        try {
            if (isEditing) {
                payload.id = usuario.id;
                let responseEditar = await myApi.put('/usuarios/editarUsuario', payload);

                if(responseEditar.data.success){
                    Swal.fire({
                        icon: 'success',
                        title: 'Usuario editado',
                    });
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al editar el usuario',
                    });
                }
            } else {
                let responseCrear = await myApi.post('/usuarios/crearUsuario', payload);

                if(responseCrear.data.success){
                    Swal.fire({
                        icon: 'success',
                        title: 'Usuario creado',
                    });
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al crear el usuario',
                    });
                }
            }
            refresh();
            onClose();
        } catch (error) {
            console.error('Error saving user:', error);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>{isEditing ? 'Editar Usuario' : 'Crear Usuario'}</DialogTitle>
            <DialogContent>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ handleSubmit }) => (
                        <Form onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <Grid2 container spacing={2}>
                                <Grid2 size={{xs: 12, sm: 6}}>
                                    <MyTextInput
                                        name="nombre"
                                        label="Nombre"
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6 }}>
                                    <MyTextInput
                                        name="apellido"
                                        label="Apellido"
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6 }}>
                                    <MyTextInput
                                        name="email"
                                        label="Email"
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6 }}>
                                    <MyPasswordInput
                                        name="password"
                                        label="Contraseña"
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6 }}>
                                    <MyAutoComplete
                                        name="id_perfil"
                                        label="Perfil"
                                        options={perfiles}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6 }}>
                                    <MyAutoComplete
                                        name="estado"
                                        label="estado"
                                        options={[{ value: 1, label: 'Activo' }, { value: 0, label: 'Inactivo' }]}
                                    />
                                </Grid2>
                                <DialogActions style={{ justifyContent: 'flex-end' }}>
                                    <Button type="submit" variant="contained" color="primary">
                                        Guardar
                                    </Button>
                                    <Button onClick={onClose}>Cancelar</Button>
                                </DialogActions>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    )
}

export default CrearEditarUsuarioModal